import type { AxiosInstance } from 'axios';
import apiClient from '@/services/api/client';
import type { TicketClient } from '../types';

interface TaskEventTicketResponse {
  ticket: string;
  expiresAt: string;
}

export function createTicketClient(http: Pick<AxiosInstance, 'post'> = apiClient): TicketClient {
  return {
    refresh: async (pathTaskType, taskId) => {
      const response = (await http.post<TaskEventTicketResponse>(
        `/task-events/${pathTaskType}/${taskId}/ws-ticket`
      )) as unknown as TaskEventTicketResponse;
      return response.ticket;
    },
  };
}
